<template>
	<div class="game-outer" 
		:style="{transform:`scale(${beishu})`,WebkitTransform:`scale(${beishu})`,MozTransform:`scale(${beishu})`}">
		<div class="game-wrap" :style="{width:(width)+'px',backgroundImage:`url(${img})`,}">
			<div class="puzzle" :style="{width:width+'px',height:height+'px'}">
			    <div
			      v-for="(item,index) in blockPoints"
			      :key="item.id"
			      :style="{width:blockWidth+'px',
			        height:blockHeight+'px',
			        left:item.x+'px',top:item.y+'px',
			        backgroundImage:`url(${img})`,
			        backgroundPosition:`-${correctPoints[index].x}px -${correctPoints[index].y}px`,
			        opacity: index===blockPoints.length-1 && 0 }"
			      v-on:click="handleClick"
			      class="puzzle__block class-one"
			      :class="[index===0 ? 'class-one' : '' , index=== 1 ? 'class-two' : '',
			      index===2 ? 'class-three' : '' , index=== 3 ? 'class-thour' : '',
			      index===4 ? 'class-five' : '' , index=== 5 ? 'class-six' : '',
			      index===6 ? 'class-seven' : '' , index=== 7 ? 'class-eight' : '']" 
			      :ref="index===blockPoints.length-1?'empty':'block'"
			      :data-correctX="correctPoints[index].x"
			      :data-correctY="correctPoints[index].y">
				</div>
		    </div>
		</div>
	</div>
</template>
<script>
import { showToast ,changeFormState} from "@/util/utils.js";
export default {
  props: {
    img: {
      // 图片路径
      type: String,
      required: true,
    },
    width: {
      // 图片总宽度
      type: Number,
      default: 800,
    },
    height: {
      // 图片总高度
      type: Number,
      default: 800,
    },
    row: {
      // 行数
      type: Number,
      default: 3,
    },
    col: {
      // 列数
      type: Number,
      default: 3,
    },
    beishu:Number,
    // status:Boolean,
  },
  data() {
    return {
      status: {
        type: String,
        default: "进行中......",
      },
      hour:0,//定义时，分，秒，毫秒并初始化为0；
      minute:0,
      second:0,//秒
      ms:0,//毫秒
      time:'',
    };
  },
  created(){
    this.timeStart();

    // this.status = "胜利";
    // this.$emit("getStatus");
    // this.$store.commit("updateRoleState", true);
    // this.$emit('statusChanged', true);
  },
  methods: {
  	zhikong(){
  		const empthDom = this.$refs.empty[0];
  		empthDom.style.opacity = 0;
  	},
  	initFun(){
  		this.status = "进行中......";
  	},
    handleClick(e) {
      //console.log(e)
      const blockDom = e.target;
      const empthDom = this.$refs.empty[0];
      const { left, top } = blockDom.style;
      if (!this.isAdjacent(blockDom, empthDom)) {
        return;
      }
      //交换元素
      blockDom.style.left = empthDom.style.left;
      blockDom.style.top = empthDom.style.top;
      empthDom.style.left = left;
      empthDom.style.top = top;
      const winFlag = this.winCheck();
      if (winFlag) {
        //console.log('success');
        this.winGame(empthDom);
      }
    },
    isAdjacent(blockDom, empthDom) {
      // 判断是否相邻
      const { left: blockLeft, top: blockTop, width, height } = blockDom.style;
      const { left: emptyLeft, top: emptyTop } = empthDom.style;
      const xDis = Math.floor(
        Math.abs(parseFloat(blockLeft) - parseFloat(emptyLeft))
      );
      const yDis = Math.floor(
        Math.abs(parseFloat(blockTop) - parseFloat(emptyTop))
      );
      const flag =
        (blockLeft === emptyLeft && yDis === parseInt(height)) ||
        (blockTop === emptyTop && xDis === parseInt(width));
      return flag;
    },
    winCheck() {
      // 判断是否完成
      const blockDomArr = this.$refs.block;
      return blockDomArr.every((dom) => {
        const { left: domLeft, top: domTop } = dom.style;
        const { correctx: correctX, correcty: correctY } = dom.dataset;
        const flag =
          parseInt(domLeft) === parseInt(correctX) &&
          parseInt(domTop) === parseInt(correctY);
        return flag;
      });
      // console.log(blockDomArr.length);
    },
    winGame(empthDom) {
      //通关
      setTimeout(() => { //拼图成功
      	var time=(this.minute*60)+this.second;
        time=time+"."+this.ms;
        time=parseFloat(time);
        if(time<3.1){
          showToast(this, "Submission failed, please contact the administrator.");
          return;
        }else{
          this.status = "胜利";
          //alert("恭喜通关");
          empthDom.style.opacity = 1;
          this.$emit("getStatus");
          this.$store.commit("updateRoleState", true);
          this.$emit('statusChanged', true);
        }
      }, 300);
    },
    goToNextLevel() {
      const answerFlag = window.confirm("现在进行下一关么？");
      if (answerFlag) {
        this.status = "进行中......";
        this.$emit("next");
      }
    },
    blockPointsFun() {
      const points = this.correctPoints;
      const length = points.length; //数组的长度
      const lastEle = points[length - 1]; //最后一个元素
      const newArr = [...points];
      newArr.length = length - 1;
      //打乱顺序
      newArr.sort(() => Math.random() - 0.5);
      newArr.push(lastEle);
      this.blockPoints=newArr;
      return newArr;
    },
    timeStart(){
      this.time =setInterval(this.timer,10)
    },
    timer () {//定义计时函数
	    this.ms =this.ms +10        //毫秒
	    if (this.ms >=1000) {
			this.ms =0
	        this.second =this.second +1        //秒
	    }
		if (this.second >=60) {
			this.second =0
		    this.minute =this.minute +1        //分钟
		}
		if (this.minute >=60) {
			this.minute =0
			this.hour =this.hour +1        //小时
			this.stop(); //超时暂停时间
		}
	},
	stop () {
		clearInterval(this.time)
	},
  },
  computed: {
    blockWidth() {
      return this.width / this.col;
    },
    blockHeight() {
      return this.height / this.row;
    },
    correctPoints() {
      const { row, col, blockWidth, blockHeight } = this;
      const arr = [];
      for (let i = 0; i < row; i++) {
        for (let j = 0; j < col; j++) {
          arr.push({
            x: j * blockWidth,
            y: i * blockHeight,
            id: new Date().getTime() + Math.random() * 100,
          });
        }
      }
      return arr;
    },
    blockPoints() {
      var allList = [
        [
          {x: 0, y: 533.3333333333334, id: 1639012076208.2295},
          {x: 0, y: 266.6666666666667, id: 1639012076202.646},
          {x: 0, y: 0, id: 1639012076270.1846},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639012076299.5151},
          {x: 266.6666666666667, y: 0, id: 1639012076241.9663},
          {x: 533.3333333333334, y: 0, id: 1639012076232.9768},
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639012076282.9163},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639012076202.8726},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639012076292.4973}
        ],
        [
          {x: 0, y: 266.6666666666667, id: 1639012344464.0115},
          {x: 0, y: 0, id: 1639012344546.8108},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639012344508.7551},
          {x: 266.6666666666667, y: 0, id: 1639012344533.9163},
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639012344528.6587},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639012344544.7563},
          {x: 533.3333333333334, y: 0, id: 1639012344487.9492},
          {x: 0, y: 533.3333333333334, id: 1639012344550.3113},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639012344530.6843}
        ],
        [
          {x: 0, y: 266.6666666666667, id: 1639012528981.8086},
          {x: 533.3333333333334, y: 0, id: 1639012528970.4524},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639012528992.4639},
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639012528943.078},
          {x: 266.6666666666667, y: 0, id: 1639012528929.2998},
          {x: 0, y: 0, id: 1639012528959.6992},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639012528959.9697},
          {x: 0, y: 533.3333333333334, id: 1639012528978.3179},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639012528936.4873}
        ],
        [
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639012745372.8738},
          {x: 0, y: 0, id: 1639012745384.3057},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639012745303.2986},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639012745336.9136},
          {x: 0, y: 266.6666666666667, id: 1639012745390.5815},
          {x: 266.6666666666667, y: 0, id: 1639012745301.327},
          {x: 0, y: 533.3333333333334, id: 1639012745340.7607},
          {x: 533.3333333333334, y: 0, id: 1639012745361.4116},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639012745391.8162}
        ],
        [
          {x: 0, y: 533.3333333333334, id: 1639012930116.592},
          {x: 0, y: 0, id: 1639012930051.939},
          {x: 266.6666666666667, y: 0, id: 1639012930052.3203},
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639012930130.8403},
          {x: 533.3333333333334, y: 0, id: 1639012930079.854},
          {x: 0, y: 266.6666666666667, id: 1639012930066.3652},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639012930144.2688},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639012930113.1255},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639012930110.7346}
        ],
        [
          {x: 0, y: 533.3333333333334, id: 1639013049823.839},
          {x: 0, y: 0, id: 1639013049764.1172},
          {x: 266.6666666666667, y: 0, id: 1639013049823.8625},
          {x: 533.3333333333334, y: 0, id: 1639013049792.2527},
          {x: 0, y: 266.6666666666667, id: 1639013049830.5393},
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639013049793.084},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639013049819.964},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639013049801.093},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639013049827.1755}
        ],
        [
          {x: 0, y: 0, id: 1639013218485.614},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639013218511.5374},
          {x: 266.6666666666667, y: 0, id: 1639013218459.6453},
          {x: 533.3333333333334, y: 0, id: 1639013218486.4763},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639013218485.439},
          {x: 0, y: 266.6666666666667, id: 1639013218481.2786},
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639013218429.5674},
          {x: 0, y: 533.3333333333334, id: 1639013218484.0981},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639013218430.0535}
        ],
        [
          {x: 0, y: 533.3333333333334, id: 1639013405334.2441},
          {x: 0, y: 0, id: 1639013405331.0605},
          {x: 266.6666666666667, y: 0, id: 1639013405391.0432},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639013405381.1548},
          {x: 533.3333333333334, y: 0, id: 1639013405386.5928},
          {x: 0, y: 266.6666666666667, id: 1639013405371.9114},
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639013405346.4346},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639013405407.3962},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639013405389.8584}
        ],
        [
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639014221912.3213},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639014221973.9749},
          {x: 266.6666666666667, y: 0, id: 1639014221992.6777},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639014221919.8853},
          {x: 0, y: 533.3333333333334, id: 1639014221918.9531},
          {x: 533.3333333333334, y: 0, id: 1639014221970.9734},
          {x: 0, y: 0, id: 1639014221907.4558},
          {x: 0, y: 266.6666666666667, id: 1639014221993.582},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639014221951.6375}
        ],
        [
          {x: 266.6666666666667, y: 0, id: 1639014431297.7378},
          {x: 533.3333333333334, y: 266.6666666666667, id: 1639014431263.634},
          {x: 266.6666666666667, y: 533.3333333333334, id: 1639014431261.7366},
          {x: 0, y: 0, id: 1639014431286.5513},
          {x: 533.3333333333334, y: 0, id: 1639014431287.2087},
          {x: 0, y: 266.6666666666667, id: 1639014431304.208},
          {x: 266.6666666666667, y: 266.6666666666667, id: 1639014431318.8423},
          {x: 0, y: 533.3333333333334, id: 1639014431267.9395},
          {x: 533.3333333333334, y: 533.3333333333334, id: 1639014431263.1726}
        ]
      ]
      var len = allList.length;
      var num = Math.floor(Math.random()*len); // 可均衡获取0到(len-1)的随机整数
      return allList[num];

      // const points = this.correctPoints;
      // const length = points.length; //数组的长度
      // const lastEle = points[length - 1]; //最后一个元素
      // const newArr = [...points];
      // newArr.length = length - 1;
      // //打乱顺序
      // newArr.sort(() => Math.random() - 0.5);
      // newArr.push(lastEle);
      // console.log("正确顺序 九个格子位置 newArr", newArr)
      // return newArr;
    },
  },
};
</script>
<style>
.game-outer{
  transform-origin: 0 0;
}
.puzzle {
  position: relative;
  box-sizing: content-box;
  /* border: 2px solid #3e9af9; */
  background: rgba(0,0,0,0.8);
  transition: all 1s ease-out;
}
.puzzle .puzzle__block:after{
  color: white;
	padding: 15px;
  display: inline-block;
}
.puzzle .class-one:after{
	content:"1";
}
.puzzle .class-two:after{
	content:"2";
}
.puzzle .class-three:after{
	content:"3";
}
.puzzle .class-thour:after{
	content:"4";
}
.puzzle .class-five:after{
	content:"5";
}
.puzzle .class-six:after{
	content:"6";
}
.puzzle .class-seven:after{
	content:"7";
}
.puzzle .class-eight:after{
	content:"8";
}
.puzzle .class-nine:after{
	content:"9";
}
.puzzle__block {
  /*border: 1px solid #ffffff;*/
  box-sizing: border-box;
  /* background-color: rebeccapurple; */
  position: absolute;
  transition: all 0.3s;
  /*text-align: center;*/
  text-align: right;
  font-size: 40px;
}
.game-outer .index_span{
    color: white;
    font-size: 40px;
    display: inline-block;
    width: 100%;
    text-align: center;
    margin-top: calc((100% - 30px) / 2);
}
@media screen and (max-width: 768px){
	
}
</style>


// WEBPACK FOOTER //
// src/components/Puzzle.vue